var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('am2-link-button-dropdown',{attrs:{"items":_vm.timezoneItems,"item-key":_vm.realVal,"placeholder":"Select timezone","search-placeholder":"Search timezone","has-search":"","no-option-text":"No timezones found","max-height":"300px","dropdown-style":{
    width: '280px',
  }},on:{"select":_vm.handleTimezoneSelect,"searchStringChange":_vm.handleSearchStringChange}})}
var staticRenderFns = []

export { render, staticRenderFns }